import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { FlightFragment } from '@websky/graphql';
import { ThemeProvider, useTheme } from '../../../../../theme';
import Flight from '../../../../../Flight';
import { ExchangeRefundContentWrapper } from '@entities/order';
import { CdnIcon } from '@shared/ui';

export interface Props {
	className?: string;
	selectedFlights: FlightFragment[];
	controls?: React.ReactNode;
	hideHeader?: boolean;
}

const SelectedFlights: React.FC<Props> = ({ className, selectedFlights, controls, hideHeader }) => {
	const { t } = useTranslation('Exchange');
	const { SelectedFlights: theme } = useTheme('Widgets').Exchange;

	return (
		<ThemeProvider
			value={{
				Entities: {
					Order: {
						ExchangeRefundContentWrapper: {
							icon: theme.icon_selected,
							header: cn({ [theme.hidden]: hideHeader })
						}
					}
				},
				DesktopFlightRoute: {
					DesktopFlightRouteStyles: { container: theme.flight }
				},
				MobileFlight: {
					FlightStyles: { flight: theme.flight, readonly: theme.flight_readonly }
				},
				MobileSegmentInfo: {
					MobileSegmentFlat: { card: theme.flight__card, aircraft: theme.aircraft }
				}
			}}
		>
			<ExchangeRefundContentWrapper
				className={className}
				icon={<CdnIcon icon="Info/Choosed" />}
				title={t('SelectedFlights.Title')}
				controls={controls}
			>
				<div className={theme.flights}>
					{selectedFlights.map((flight, index) => (
						<Flight
							key={flight.id}
							flight={{ ...flight, pricesForFareGroups: [] }}
							isReturnFlight={flight.segmentGroups?.[index]?.groupId === '1'}
							isPreOpenAvailable={false}
							isPreOpen={false}
							hidePrice={true}
							readonly={true}
							isSelected={true}
						/>
					))}
				</div>
			</ExchangeRefundContentWrapper>
		</ThemeProvider>
	);
};

export default SelectedFlights;
